import { useStore } from '@/hooks/useStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { ITEMS_CONST, ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import Header from '@/components/layout/Header';
import { flowResult } from 'mobx';
import imgSend from '@/assets/images/pngs/NavigationArrow.png';
import { Button } from '@/components/common/Button';
import warningImg from '@/assets/images/pngs/Warning.png';
import doneImg from '@/assets/images/pngs/Section.png';
import { handleLongText } from '@/utils/utils';

export default observer(function DetailItemCollected() {
    // store
    const {
        itemsStore: { getDetailItemCollected, detailItem, putUseItem, collectItem, reportItem, setIdDetail },
        modalStore: { showAlertModal, hideModal, showModal }
    } = useStore();
    const { t } = useTranslation();
    const location = useLocation();
    const { itemId, isGeting } = location.state || {};
    const navigate = useNavigate();
    const goBack = () => {
        if (isGeting) {
            navigate(ROUTES.listNearBy.href);
        } else {
            navigate(ROUTES.collectefItems.href);
        }
    };

    useEffect(() => {
        itemId && getDetailItemCollected(itemId);
    }, [itemId]);

    const handleRightAction = () => {
        if (!detailItem) return;
        setIdDetail(detailItem.id);
        navigate(ROUTES.home.href);
    };

    const handleConfirmUseItem = async () => {
        const res = await flowResult(putUseItem(detailItem?.id));
        if (res) {
            getDetailItemCollected(itemId);
            hideModal('use-item');
            toastify('success', t('messages.useSuccess'));
            goBack();
        }
    };

    const handleUseItem = async () => {
        showModal({
            id: 'use-item',
            title: t('text.confirmation'),
            cancelButton: false,
            saveButton: false,
            showBorder: true,
            titleClassName: 'absolute top-4 left-4',
            content: (
                <div className='w-full text-start flex flex-col justify-center items-center'>
                    <p className='text-[15px] font-medium text-gray'>{t('text.confirmUseItem', { itemName: detailItem?.item })}</p>
                    <div className='flex flex-row text-center mt-6 w-full justify-center space-x-[10px]'>
                        <Button
                            variant='white'
                            onClick={async () => {
                                hideModal('use-item');
                            }}
                            className='w-full'
                        >
                            {t('text.cancle')}
                        </Button>
                        <Button
                            variant='main'
                            onClick={async () => {
                                handleConfirmUseItem();
                            }}
                            className='w-full'
                        >
                            {t('text.ok')}
                        </Button>
                    </div>
                </div>
            )
        });
    };
    const handleCollectItem = async () => {
        const res = await flowResult(collectItem(itemId));
        if (res) {
            showModal({
                id: 'collect-success',
                showCloseIcon: false,
                cancelButton: false,
                saveButton: false,
                closeWhenOutside: true,
                onCancel: () => {
                    navigate(ROUTES.listNearBy.href);
                },
                content: (
                    <div className='w-full flex flex-col justify-center items-center'>
                        <img src={doneImg} alt={doneImg} className='w-[263px] h-[244px]' />
                        <p className='text-[15px] font-semibold text-gray mt-6'>{t('text.getted')}</p>
                    </div>
                )
            });
        }
    };
    const handleConfirmReportItem = async () => {
        const res = await flowResult(reportItem(itemId));
        if (res) {
            hideModal('report-item');
            toastify('success', t('text.reportSuccess'));
            setTimeout(() => {
                navigate(ROUTES.listNearBy.href);
            }, 240);
        }
    };

    const handleReport = async () => {
        showModal({
            id: 'report-item',
            title: t('text.confirmReport'),
            saveButton: false,
            cancelButton: false,
            showBorder: true,
            titleClassName: 'absolute top-4 left-4',
            content: (
                <div className='w-full text-start flex flex-col justify-center items-center'>
                    <p className='text-[13px] font-medium text-textDes'>
                        <span className=''>{t('text.confirmReportDes', { itemName: detailItem?.item })}</span>
                        <span className='text-txtReport'>{t('text.report')}</span>
                        <span>{t('text.confirmReportDes2')}</span>
                    </p>
                    <div className='flex flex-row text-center mt-6 w-full justify-center space-x-[10px]'>
                        <Button
                            variant='white'
                            onClick={() => {
                                hideModal('report-item');
                            }}
                            className='w-full'
                        >
                            {t('text.cancle')}
                        </Button>
                        <Button
                            variant='main'
                            onClick={handleConfirmReportItem}
                            className='w-full'
                        >
                            {t('text.ok')}
                        </Button>
                    </div>
                </div>
            )
        });
    };
    return (
        <div className='w-screen h-screen flex flex-col justify-start pt-[72px]'>
            <Header title={detailItem?.item ? handleLongText(detailItem.item, 8) : ''} goBackFunction={goBack} iconRight={imgSend} iconRightFunction={handleRightAction} />
            <div className={`mx-4 h-[calc(100vh-72px-24px)] flex flex-col justify-between ${detailItem?.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'filter grayscale brightness-100'}`}>
                <div className='my-4 overflow-y-scroll scrollbar-hide'>
                    <div className=' relative'>
                        <img
                            src={detailItem?.file?.path}
                            alt={detailItem?.file?.filename}
                            className='w-full rounded-sm'
                        />
                        {detailItem?.itemType === ITEMS_CONST.ITEM_TYPE.COUPON && (
                            <div className='absolute top-0 right-0 bg-gradient-to-r from-[#EA4335] to-[#F47843] text-white text-xs px-[12px] py-[2px] rounded-bl-sm rounded-tr-sm'>
                                {t('text.coupon')}
                            </div>
                        )}
                    </div>

                    <div className='flex justify-between items-center mt-4 '>
                        <p className={`font-semibold text-[17px] text-gray w-[70vw] ${detailItem?.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'text-textInactive'} truncate whitespace-nowrap break-words`}>{detailItem?.item}</p>
                        {isGeting && (
                            <button onClick={handleReport} className='bg-bgReport text-white text-[13px] font-medium flex items-center space-x-[2px] px-2 py-1 rounded'>
                                <img src={warningImg} alt={warningImg} className='w-3 h-3' />
                                <p>{t('text.report')}</p>
                            </button>
                        )}
                    </div>
                    <p className={`text-textRed text-[13px] mt-1 font-medium ${detailItem?.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'text-textInactive'} truncate whitespace-nowrap`}>{detailItem?.userCreated?.username}</p>
                    {detailItem?.status !== ITEMS_CONST.STATUS.UN_PUBLISHED && <p className={`text-textDes text-[13px] mt-1 break-words ${detailItem?.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'text-textInactive'}`}>{detailItem?.description}</p>}
                </div>
                {(detailItem?.itemType !== ITEMS_CONST.ITEM_TYPE.NOT_SET || isGeting) && (
                    <Button
                        className='w-full '
                        variant='main'
                        disabled={detailItem?.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED}
                        onClick={isGeting ? handleCollectItem : handleUseItem}
                    >
                        {t(isGeting ? 'text.getIt' : 'text.use')}
                    </Button>
                )}
            </div>
        </div>
    );
});
